let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ic5fz")).then(() => parcelRequire('6ibCj'));